import React from "react";
import { useState } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { IoMdArrowBack } from "react-icons/io";
import { Button, Container, Modal } from "reactstrap";
import contest1Img from "../../assets/img/custom/contestImg1.jpg";
import contest2Img from "../../assets/img/custom/contestImg2.jpg";

const Contests = () => {
  const [videosModal, setVideosModal] = useState(false);

  const handleVideosModal = () => {
    setVideosModal(!videosModal);
  };

  return (
    <>
      <button type="button" className="text-white btn btn-primary mx-4 my-3" onClick={() => window.history.back()}>
        <IoMdArrowBack /> Go Back
      </button>{" "}
      <Container>
        <div className="text-center my-4">
          <a
            href="https://youtu.be/HnGCAc-2z24"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://youtu.be/HnGCAc-2z24
          </a>
        </div>
        <div className="text-center mb-4">
          <a
            href="https://fhp-fans.web.app/auth/login?redirect=/fan/contest"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={contest1Img} alt="" className="w-75 my-4" />
          </a>
          <img
            src={contest2Img}
            alt=""
            className="w-75 pointer"
            onClick={handleVideosModal}
          />
        </div>
      </Container>
      <Modal isOpen={videosModal} toggle={handleVideosModal} size="sm">
        <Container className="p-4 circumstance semi_final text-center">
          <p className="text-center">Click on the button for watch video</p>
          <a
            href="https://www.youtube.com/watch?v=810Krg8w0oQ"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-primary"
          >
            OVERVIEW
          </a>
          <a
            href="https://youtu.be/YQ9uYbaRI1M"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-primary"
          >
            HOW SCORES
          </a>

          <div className="text-right mt-4">
            <Button color="danger" size="sm" onClick={handleVideosModal}>
              Close
            </Button>
          </div>
        </Container>
      </Modal>
    </>
  );
};

export default Contests;
